import React from "react";
import Logo from "../Logo/Logo";
import { Container } from "../Common__style/Micro-style";
import MenuItem from "./Manu__item";
import MenuBurger from "./MenuBurger";
import { MenuSell, MenuBody, MenuItems, MenuUnderline, MenuBurgerWrapper } from "./Menu-style";



export default class Menu extends React.Component {
   constructor(props) {
      super(props)
      this.state = {
         menuOpen: false
      }
   }
   /* constructor можно заменить простой записью (вариант синтаксиса)
   state = { menuOpen: true }
   */



   render() {

      let color = {
         colorFont: 'rgb(0, 0, 0);)',
         colorTriangel: 'rgba(0, 164, 229, 1)',
         fontSize: '1.3rem'
      };

      //  console.log(this.state.menuOpen);

      const Menu =
         <MenuItems menuHiden={this.state.menuOpen}>
            <MenuItem name={'home'} />
            <MenuItem name={'about'} />
            <MenuItem name={'rvices'} />
            <MenuItem name={'work'} />
            <MenuItem name={'contact'} />
         </MenuItems>;

      const hhh = this.state.menuOpen;



      // console.log(this.props);
      return (
         <MenuSell>
            <Container>
               <div>
                  <MenuBody>
                     <Logo options={color}></Logo>
                     {Menu}
                     <MenuBurgerWrapper onClick={menuActive.bind(this)}>
                        <MenuBurger />
                     </MenuBurgerWrapper>
                  </MenuBody>
               </div>
            </Container>
            <MenuUnderline />
         </MenuSell>
      )
   }

   /*  menuActive = () => {
       this.setState({ menuOpen: !this.state.menuOpen });
    };
    при такой функции внутри компонента не нужно связывать this с this внешней функции,
    запись события будет onClick={this.menuActive}
  */

}

function menuActive() {
   // console.log(this.state.menuOpen);
   this.setState({ menuOpen: !this.state.menuOpen });
}

